import React, { useState, useEffect } from 'react'
import PowerBIReport from "./PowerBIReport";
import TargetReportConfig from '../../config/TargetReport';


const TargetUsageReport = (props: any) => {
   const [embedData, setEmbedData] = useState<any>(null);

    useEffect(() => {
        const fetchEmbedData = async () => {
            try {             
                const response = await fetch(
                    TargetReportConfig.apiEndpoints.getTargetUsageReport,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (!response.ok) {
                    throw new Error('Failed to fetch Target Usage Report');
                }
                const data = await response.json();
                setEmbedData(data);
            } catch (error) {
                console.error('Error fetching Target Usage Report data:', error);
            }
        };

        fetchEmbedData();
    }, []);

    if (!embedData) {
        return <p>Loading Target Usage Report…</p>;
    }

    return <PowerBIReport {...embedData} />;
};
    
    export default TargetUsageReport;